module.exports = __webpack_public_path__ + "static/media/feedback-section.b486394c.png";